import { CallScreening } from "@/components/call-screening";
import { organisationCallscreeningQueryOptions, organisationQueryOptions } from "@/server/organisations";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/_dashboard/organisations/$orgId/call-screening")({
  component: RouteComponent,
  beforeLoad: ({ location, params }) => {
    const search = (location as any).search || {};
    if (!search.tab) {
      throw redirect({
        to: "/organisations/$orgId/call-screening",
        params: { orgId: params.orgId },
        replace: true,
        search: { ...search, tab: "rules" },
      });
    }
  },
  loader: async ({ context, params }) => {
    return {
      crumb: "Call Screening",
    };
  },
});

function RouteComponent() {
  const { orgId } = Route.useParams();
  const organisationQuery = useQuery(organisationQueryOptions(Number(orgId)));
  const organisation = organisationQuery.data as { name?: string } | undefined;
  const organisationCallscreeningQuery = useQuery(organisationCallscreeningQueryOptions(Number(orgId)));
  const organisationCallscreeningData = organisationCallscreeningQuery.data as
    | {
        incoming?: { modify: string; black: string; white: string };
        outgoing?: { modify: string; black: string; white: string };
      }
    | undefined;

  useEffect(() => {
    if (!orgId) return;
    void organisationQuery.refetch();
    void organisationCallscreeningQuery.refetch();
  }, [orgId, organisationQuery.refetch, organisationCallscreeningQuery.refetch]);

  return (
    <CallScreening
      resourceId={Number(orgId)}
      callscreeningData={organisationCallscreeningData}
      resource={organisation}
      resourceType="organisation"
      loading={organisationCallscreeningQuery.isLoading}
    />
  );
}
